import { Routes } from '@angular/router';
import { authGuard, roleGuard } from './services/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login').then((m) => m.LoginPage),
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./pages/dashboard/dashboard').then((m) => m.DashboardPage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['SUPER_ADMIN', 'MANAGER'] }
  },
  {
    path: 'elevators',
    loadComponent: () => import('./pages/elevator-list/elevator-list').then((m) => m.ElevatorListPage),
    canActivate: [authGuard]
  },
  {
    path: 'elevators/:id',
    loadComponent: () => import('./pages/elevator-detail/elevator-detail').then((m) => m.ElevatorDetailPage),
    canActivate: [authGuard]
  },
  {
    path: 'public/elevators/:id/monthly-report/:yyyymm',
    loadComponent: () => import('./pages/public/monthly-report/monthly-report').then((m) => m.MonthlyReportPage),
  },
  {
    path: 'public/elevators/:id/monthly-report',
    loadComponent: () => import('./pages/public/monthly-report/monthly-report').then((m) => m.MonthlyReportPage),
  },
  {
    path: 'public/employee-monthly-reports/:employeeId/:yyyymm',
    loadComponent: () => import('./pages/public/employee-monthly-reports/employee-monthly-reports').then((m) => m.EmployeeMonthlyReportsPage),
  },
  {
    path: 'public/employee-monthly-reports/:employeeId',
    loadComponent: () => import('./pages/public/employee-monthly-reports/employee-monthly-reports').then((m) => m.EmployeeMonthlyReportsPage),
  },
  {
    path: 'public/employee-monthly-reports',
    loadComponent: () => import('./pages/public/employee-monthly-reports/employee-monthly-reports').then((m) => m.EmployeeMonthlyReportsPage),
  },
  {
    path: 'public/complaints/:elevatorNumber',
    loadComponent: () => import('./pages/public/public-complaint/public-complaint').then((m) => m.PublicComplaintComponent),
  },
  {
    path: 'public/complaints',
    loadComponent: () => import('./pages/public/public-complaint/public-complaint').then((m) => m.PublicComplaintComponent),
  },
  {
    path: 'complaints',
    loadComponent: () => import('./pages/complaints/complaints').then((m) => m.ComplaintsComponent),
    canActivate: [authGuard]
  },
  {
    path: 'elevator-map',
    loadComponent: () => import('./pages/elevator-map/elevator-map').then((m) => m.ElevatorMapPage),
    canActivate: [authGuard]
  },
  {
    path: 'board',
    children: [
      { path: '', loadComponent: () => import('./pages/board/board-list').then((m) => m.BoardListPage) },
      { path: 'create', loadComponent: () => import('./pages/board/board-form').then((m) => m.BoardFormPage), canActivate: [authGuard, roleGuard], data: { roles: ['SUPER_ADMIN', 'MANAGER'] } },
      { path: ':id', loadComponent: () => import('./pages/board/board-detail').then((m) => m.BoardDetailPage) },
      { path: ':id/edit', loadComponent: () => import('./pages/board/board-form').then((m) => m.BoardFormPage), canActivate: [authGuard, roleGuard], data: { roles: ['SUPER_ADMIN', 'MANAGER'] } },
    ]
  },
  {
    path: 'control-panels',
    loadComponent: () => import('./pages/control-panels/control-panels').then((m) => m.ControlPanelsPage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['SUPER_ADMIN'] }
  },
  {
    path: 'error-codes',
    redirectTo: 'control-panels',
    pathMatch: 'full'
  },
  {
    path: 'admin-console',
    loadComponent: () => import('./pages/admin-console/admin-console').then((m) => m.AdminConsolePage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['SUPER_ADMIN'] }
  },
  {
    path: 'manager-console',
    loadComponent: () => import('./pages/manager-console/manager-console').then((m) => m.ManagerConsolePage),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['MANAGER'] }
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '**',
    loadComponent: () => import('./pages/notfound/notfound').then((m) => m.NotFoundPage),
  }
];
